<template>
  <div>
    <el-row type="flex" justify="center">
      <div class="logo"></div>
    </el-row>
    <el-row type="flex" justify="center">
      <div class="corporation">福建省海运集团中平船舶管理有限公司</div>
    </el-row>
    <el-row type="flex" justify="center">
      <div class="corporation_title">海员岗前培训系统</div>
    </el-row>
    <!-- 登录 -->
    <div v-if="login === true">
      <el-row type="flex" justify="space-around">
        <div class="user_input">
          <el-input placeholder="请输入身份证号" v-model="logins.id_number"></el-input>
        </div>
      </el-row>
      <el-row type="flex" justify="space-around">
        <div class="user_input">
          <el-input placeholder="请输入密码" v-model="logins.pwd" show-password></el-input>
        </div>
      </el-row>
      <el-row type="flex" justify="space-around">
        <div class="user_input">
          <div class="login_btn" @click="loginBtn">登录</div>
        </div>
      </el-row>
      <el-row type="flex" justify="space-around">
        <div class="gotoReg" @click="gotoReg">立即注册</div>
      </el-row>
    </div>
    <!-- 注册 -->
    <div v-if="register === true">
      <el-form :model="reg" :rules="regRules" ref="regtable">
        <el-row type="flex" justify="center">
          <el-form-item prop="name" class="user_input">
              <el-input placeholder="请输入姓名" v-model="reg.name"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="age" class="user_input">
            <el-input onkeyup="value=value.replace(/[^\d]/g,0)" placeholder="请输入年龄" type="number" min=1 v-model="reg.age"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="phone" class="user_input">
            <el-input placeholder="请输入手机号" v-model="reg.phone"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="id_number" class="user_input">
            <el-input placeholder="请输入身份证号" v-model="reg.id_number"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="station_id" class="user_input">
            <el-cascader style="width: 100%;"
            placeholder="请选择部门及岗位"
            v-model="reg.station_id"
            :options="optionsList">
            </el-cascader>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="sex" class="user_input">
            <el-select style="width: 100%;" clearable v-model="reg.sex" placeholder="请选择性别">
              <el-option
                v-for="item in sexOptions "
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="is_onShip" class="user_input">
            <el-select style="width: 100%;" clearable v-model="reg.is_onShip" placeholder="是否在船">
              <el-option
                v-for="item in onShipOptions "
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="center">
          <el-form-item prop="serve_ship" class="user_input">
            <el-select style="width: 100%;" clearable v-model="reg.serve_ship" placeholder="请选择目前服务的船舶">
              <el-option
                v-for="item in shipOptions "
                :key="item.id"
                :label="item.ship_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-form-item prop="pwd" class="user_input">
            <el-input placeholder="8到16个字符,大小写字母或数字" v-model="reg.pwd" show-password></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-form-item prop="secondaryPwd" class="user_input">
            <el-input placeholder="请再次输入密码" v-model="secondaryPwd" show-password></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row type="flex" justify="space-around">
        <div class="user_input">
          <div class="reg_btn" @click="regBtn">注册</div>
        </div>
      </el-row>
      <el-row type="flex" justify="space-around">
        <div class="gotoReg" @click="gotologin">立即登录</div>
      </el-row>
    </div>
    <!-- 底部 -->
    <el-row type="flex" justify="space-around">
      <div class="bottom">版权所有: 福建省海运集团中平船舶管理有限公司</div>
    </el-row>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      openid: '',
      login: true,
      register: false,
      secondaryPwd: '',
      logins: {
        id_number: '',
        pwd: ''
      },
      shipOptions: [],
      sexOptions: [
        {
          value: false,
          label: '女'
        },
        {
          value: true,
          label: '男'
        }
      ],
      onShipOptions: [
        {
          value: false,
          label: '否'
        },
        {
          value: true,
          label: '是'
        }
      ],
      reg: {
        // 身份证
        id_number: '',
        // 部门岗位
        station_id: null,
        name: '',
        pwd: '',
        branch_id: 0,
        serve_ship: null,
        // 性别, 男为true, 女为false
        sex: null,
        age: null,
        // 是否在船
        is_onShip: null,
        phone: null
      },
      // 注册数据验证
      regRules: {
        name: [
          { required: true, trigger: 'blur', message: '请输入用户名' },
          {min: 1, max: 30, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9_]{1,30}$/, message: '请输入用户名, 限中英文数字,不超过30'}
        ],
        id_number: [
          { required: true, trigger: 'blur', message: '请输入身份证号' },
          {min: 18, max: 18, pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确格式的身份证号'}
        ],
        age: [
          { required: true, trigger: 'blur', message: '请输入年龄' },
          {pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '请输入正确格式的年龄'}
        ],
        phone: [
          { required: true, trigger: 'blur', message: '请输入手机号' },
          {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确格式的手机号'}
        ],
        station_id: [
          { required: true, message: '请选择岗位', trigger: ['blur', 'change'] }
        ],
        serve_ship: [
          { required: true, message: '请选择服务的船舶', trigger: 'change' }
        ],
        pwd: [
          {required: true, trigger: 'blur', message: '请输入密码'},
          { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        ]
        // secondaryPwd: [
        //   {required: true, trigger: 'blur', message: '请确认密码'},
        //   { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        // ]
      },
      // 所有部门
      branchList: [],
      // 岗位列表
      stationList: [],
      // 选项数组
      optionsList: []
    }
  },
  created () {
    // this.getCode()
    this.getBranchList()
    this.getStationList()
    this.getShipList()
  },
  methods: {
    getLink () {
      let code = null
      let url = window.location.href
      let index = url.indexOf('code=')
      if (index !== -1) {
        let str = url.substring(index + 5, url.length - 1)
        code = str.split('&')[0]
      }
      return code
    },
    getCode () { // 非静默授权，第一次有弹框
      const code = this.getLink() // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href
      let appid = 'wx8e60d6782ac77afc'
      // 主动授权 snsapi_userinfo 静默授权 snsapi_base
      if (code == null || code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
      } else {
        this.getOpenId(code)
      }
    },
    getOpenId (code) { // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
      let sendData = {}
      sendData.data = code
      sendData.fn = this.getOpenIdFn
      sendData.vm = this
      req.Post('user/get_openId', sendData)
    },
    // openid回调
    getOpenIdFn (data) {
      window.$gmdss.token = data.token
      if (window.$gmdss.login === 'no') {
        return
      }
      if (data.type === 'yes_acc') {
        this.$router.push({path: '/index'})
      } else {
        this.openid = data.openid
        if (this.openid === undefined) {
          window.location.href = './'
        }
      }
    },
    // 注册验证
    regBtn () {
      if (this.secondaryPwd !== this.reg.pwd) {
        this.$message('两次密码不一致, 请重新输入')
        this.secondaryPwd = ''
        this.reg.pwd = ''
        return
      }
      let _ref = this.$refs.regtable
      _ref.validate((valid) => {
        if (valid) {
          let val = this.reg.station_id
          this.reg.station_id = val[1]
          if (val[0] === 3) { // 岸基需要审核
            this.reg.state = true
          }
          this.reg.branch_id = val[0]
          this.reg.pwd = this.$md5(this.reg.pwd)
          // 提交注册
          this.submitReg()
        } else {
          this.$message('注册格式不正确')
          return false
        }
      })
    },
    // 提交注册
    submitReg () {
      let sendData = {}
      sendData.data = this.reg
      sendData.fn = this.submitRegFn
      sendData.vm = this
      req.Post('user/add_user', sendData)
    },
    // 注册回调
    submitRegFn (data) {
      if (data === null || data === undefined || data === '') {
        // this.resetForm('regForm')
        this.$message('服务器出错')
      }
      if (data.err_code !== 0) {
        // this.resetForm('regForm')
        this.$message(data.err_msg)
        return
      }
      this.$message('注册成功')
      // this.resetForm('regForm')
      this.gotologin()
    },
    // 获取部门列表
    getBranchList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getBranchListFn
      sendData.vm = this
      req.Post('branch/get_branch', sendData)
    },
    getBranchListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.branchList = data.list
    },
    // 获取岗位列表
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.stationList = data.list
      this.optionsList = this.getOptions()
      this.gmdss.optionsList = this.optionsList
    },
    // 获取服务船舶列表
    getShipList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getShipListFn
      sendData.vm = this
      req.Get('ship/get_ship', sendData)
    },
    getShipListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.shipOptions = data.list
      this.gmdss.shipOptions = data.list
    },
    // 生成部门和岗位选项
    getOptions () {
      let branchList = this.branchList
      let stationList = this.stationList
      let ary = []
      for (let i in branchList) {
        let obj = {}
        obj.value = branchList[i].id
        obj.label = branchList[i].branch
        let children = this.getChildren(branchList[i].id, stationList)
        if (children.length > 0) {
          obj.children = children
        }
        ary.push(obj)
      }
      return ary
    },
    // 根据部门id获取所属岗位
    getChildren (branchId, stationList) {
      let ary = []
      for (let i in stationList) {
        if (stationList[i].branch_id === branchId) {
          let obj = {}
          obj.value = stationList[i].id
          obj.label = stationList[i].station
          ary.push(obj)
        }
      }
      return ary
    },
    // 登录提交
    loginBtn () {
      this.logins.pwd = this.$md5(this.logins.pwd)
      this.logins.openid = this.openid
      let sendData = {}
      sendData.data = this.logins
      sendData.fn = this.submitLoginFn
      sendData.vm = this
      req.Post('user/register', sendData)
    },
    // 登录回调
    submitLoginFn (data) {
      window.$gmdss.token = data.token
      this.logins.id_number = ''
      this.logins.pwd = ''
      if (data.err_code !== 0) {
        // alert(data.err_msg)
        this.$message(data.err_msg)
        return
      }
      this.$message({
        type: 'success',
        message: '登录成功',
        duration: 1000
      })
      // 跳转
      this.$router.push({path: '/index'})
    },
    // 前往注册
    gotoReg () {
      this.getBranchList()
      this.getStationList()
      this.getShipList()
      this.login = false
      this.register = true
    },
    // 前往登录
    gotologin () {
      this.login = true
      this.register = false
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getCode()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style scoped>
.logo {
  bottom: 45%;
  /* position: absolute; */
  width: 100px;
  height: 80px;
  left: 38%;
  background-image: url(../assets/00.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  margin-top: 4rem;
}
.corporation{
  font-size: 18px;
  margin-top: 5px;
}
.corporation_title{
  color: #0084ff;
  font-size: 28px;
  margin-top: 5px;
}
.user_input{
  margin: 0.5rem;
  width: 20rem;
}
.login_btn{
  width: 100%;
  height: 50px;
  background-image: url(../assets/07.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  color: rgb(255, 255, 255);
  font-size: 22px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 30px;
  display: flex;
}
.reg_btn{
  width: 100%;
  height: 50px;
  background-image: url(../assets/09.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
  color: rgb(255, 255, 255);
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;
}
.bottom{
  position: absolute;
  bottom: -13rem;
  /* width: 100%; */
  font-size: 15px;
}
.gotoReg{
  margin-top: 2rem;
  color: #00aaff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue